import { Pipe, PipeTransform } from '@angular/core';
import { ISearch } from '../shared/models/index';

@Pipe({
    name: 'searchBy',
    standalone: false
})
export class SearchByPipe implements PipeTransform {
  transform(items: Array<ISearch>, query: string): any {
    if (items) {
      return items.filter((item) => item.search(query));
    }
  }
}
